import store from "@/store";
import Web3 from "web3";
import { JsonRpcProvider, BrowserProvider, Contract, formatUnits } from "ethers";
import showToast from "@/components/toast";
import { getChainById, getChainByCode } from "@/utils/chain";
import { errors, tryChangeChain } from "@/utils/connect";
import { ERC20_ABI } from "@/utils/abi";
import BigNumber from 'bignumber.js';
import { Connection, PublicKey } from '@solana/web3.js';
import promiseRetry from "promise-retry";
import { getRpc } from "@/api/config";

const { state } = store;

let myWallet = null;
export function getWallet () {
  return myWallet
}

let solanaConnection = null
export async function getSolanaConnection (interval) {
  if (solanaConnection) return solanaConnection
  let rpc = await getRpc()
  solanaConnection = new Connection(
    rpc,
    {
      commitment: 'confirmed',
    }
  );
  return solanaConnection
}


export function sleep (interval) {
  return new Promise((resolve) => {
    setTimeout(resolve, interval);
  });
}

export const isNativeToken = (address) => {
  return (
    [
      "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
      "0x0000000000000000000000000000000000000000",
      "0x0000000000000000000000000000000000001010",
    ].indexOf(address) >= 0
  );
};

export const tryConnect = async (walletCode, connect) => {
  if (!connect) return;
  let { account, sdk, chainCode, isSelectedAddress } = await connect(state.platform.chainCode);
  myWallet = sdk;
  // if (state.platform.name == 'Hyperliquid') {
  //   if (!sessionStorage.getItem("visited")) {
  //     console.log("First page load！");
  //     disconnectWallet()
  //     sessionStorage.setItem("visited", "true");
  //     return
  //   }
  // }

  if (sdk.currentProvider) {
    const { currentProvider } = sdk || {};
    currentProvider.on("accountsChanged", async (args) => {
      console.log("accountsChanged");
      if (currentProvider && currentProvider._metamask) {
        const isUnLock = await currentProvider._metamask.isUnlocked();
        if (!isUnLock) {
          // showToast(
          //   "There is no connected accounts. Please, connect at least 1 account in your wallet."
          // );
          console.log("isUnLock");
          disconnectWallet()
          store.commit("SET_ACCOUNT", "");
          return;
        }
      }
      const account =
        currentProvider.accounts && currentProvider.accounts[0]
          ? currentProvider.accounts[0]
          : args[0];
      debugger
      store.commit("SET_ACCOUNT", account);
      // showToast('Account Changed');
    });
    currentProvider.on("chainChanged", (args) => {
      debugger
      if (!state.account) return;

      const currentChainId = parseInt(args, 16);
      const chain = getChainById(currentChainId);
      if (!chain) {
        throw new Error(errors.ChainCodeNotMath);
      }
      const { chainCode } = chain;
      store.commit("SET_CHAINCODE", chainCode);
    });
    currentProvider.on("disconnect", () => {
      debugger
      console.log("disconnect");
      disconnectWallet()
      showToast("Account Disconnected");
    });
    const provider = new BrowserProvider(sdk.eth.currentProvider);
    store.commit("SET_SIGNER", provider.getSigner());

  }
  // account = 'BAVp75ooEk2qp9NsDhgWRW6TZm741NjeXaMLWFbYWZHz'

  store.commit("SET_CHAINCODE", chainCode);
  store.commit("SET_WALLET", walletCode);
  store.commit("SET_ACCOUNT", account);

  return account;
};

export const disconnectWallet = async () => {
  if (myWallet) {
    if (myWallet.disconnect) {
      myWallet.disconnect()
    }
    if (myWallet.currentProvider && myWallet.currentProvider.disconnect) {
      myWallet.currentProvider.disconnect()
    }
    if (myWallet.currentProvider && window.ethereum) {
      await window.ethereum.request({
        "method": "wallet_revokePermissions",
        "params": [{
          "eth_accounts": {}
        }]
      });
    }
  }
  store.commit("SET_ACCOUNT", "");
}


export const getProviderByRPC = (chainCode) => {
  const params = getChainByCode(chainCode);
  if (!params) return
  const { rpcUrls } = params;
  if (!params || !rpcUrls || !rpcUrls[0]) return {};
  const provider = new JsonRpcProvider(rpcUrls[0]);
  return {
    provider,
    ...params,
  };
};

export const getMyAssetsBalance = async (tokenList, account) => {
  const AssetsMap = {};
  tokenList.forEach((item) => {
    const { chainId } = item;
    if (!AssetsMap[chainId]) {
      AssetsMap[chainId] = [];
    }
    AssetsMap[chainId].push(item);
  });
  let list = [];
  for (let chainId in AssetsMap) {
    const res = await getBalances(AssetsMap[chainId], {
      chainId,
      account,
    });
    list = list.concat(res);
  }
  return list;
};


export const getBalances = async (tokenList, params) => {
  const { chainCode, account } = params || {};
  if (!account) return tokenList;
  if (state.chainCode == chainCode && chainCode === "solana") {
    return await getSolanaBalances(tokenList, params);
  } else if (state.chainCode == chainCode && state.chainCode != "solana") {
    const erc20ABI = [
      "function balanceOf(address owner) view returns (uint256)",
      "function decimals() view returns (uint8)"
    ];
    const { chainId, provider } = getProviderByRPC(chainCode);
    try {
      for (let i = 0; i < tokenList.length; i++) {
        let item = tokenList[i]
        if (isNativeToken(item.address)) {
          let balance = await myWallet.eth.getBalance([account, "latest"]);
          const formattedBalance = formatUnits(balance, item.decimals);

          item.balance = +formattedBalance
          item.balanceAll = +formattedBalance
          item.balanceDecimals = Number(balance)
        } else {
          const tokenContract = new Contract(item.address, erc20ABI, provider);
          const balance = await tokenContract.balanceOf(account);
          const formattedBalance = formatUnits(balance, item.decimals);

          item.balance = +formattedBalance
          item.balanceAll = +formattedBalance
          item.balanceDecimals = Number(balance)
        }
      }
      return tokenList
    } catch (error) {
      return tokenList
    }
  } else {
    return tokenList
  }
};

// const connection = new Connection("https://solana-mainnet.rpc.grove.city/v1/83ac2cfd");
export const getSolanaBalances = async (tokenList, params) => {
  const { chainId, account } = params || {};
  let solanaConnection=await getSolanaConnection()
  try {
    let tokenAccounts = null
    if (tokenList.length == 1) {
      tokenAccounts = await solanaConnection.getParsedTokenAccountsByOwner(new PublicKey(account), {
        mint: new PublicKey(tokenList[0].address)
        // mint: new PublicKey('2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo')
      });
    } else {
      tokenAccounts = await solanaConnection.getParsedTokenAccountsByOwner(new PublicKey(account), {
        programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')
      });
    }
    for (let i = 0; i < tokenList.length; i++) {
      let item = tokenList[i]
      if (item.address == 'So11111111111111111111111111111111111111112') {
        const balance = await solanaConnection.getBalance(new PublicKey(account));
        const solBalance = balance / 1e9;
        item.balance = Math.floor(solBalance * 10000) / 10000;
        item.balanceAll = item.balance;
        item.balanceDecimals = balance
      } else if (item.address == '2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo') {

        let tokenAccount = await solanaConnection.getParsedTokenAccountsByOwner(new PublicKey(account), {
          mint: new PublicKey(item.address)
        });
        const accountData = tokenAccount.value[0].account.data.parsed.info;
        const tokenAmount = accountData.tokenAmount.uiAmount;
        if (tokenAmount > 0) {
          if (item.address == accountData.mint) {
            item.balance = Math.floor(tokenAmount * 10000) / 10000;
            item.balanceAll = item.balance;
            item.balanceDecimals = accountData.tokenAmount.amount;
          }
        }

        // const associatedTokenAddress = await getAssociatedTokenAddress(
        //   new PublicKey('2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo'),
        //   new PublicKey(account)
        // );
        // console.log(associatedTokenAddress.toString())
        // const tokenAccount = await getAccount(solanaConnection, associatedTokenAddress);
        // const balance = tokenAccount.amount;
        // item.balance = Math.floor(balance * 10000) / 10000;
        // item.balanceAll = item.balance;
        // item.balanceDecimals = accountData.tokenAmount.amount;

      } else if (tokenAccounts) {
        tokenAccounts.value.forEach((accountInfo) => {
          const accountData = accountInfo.account.data.parsed.info;
          const tokenAmount = accountData.tokenAmount.uiAmount;

          if (item.address == accountData.mint) {
            if (tokenAmount > 0) {
              item.balance = Math.floor(tokenAmount * 10000) / 10000;
              item.balanceAll = item.balance;
              item.balanceDecimals = accountData.tokenAmount.amount;
            } else {
              item.balance = 0
            }
          }
        });
      }
      // if (!item.balance && item.balance != 0) {
      //   let tokenAccounts2 = await solanaConnection.getParsedTokenAccountsByOwner(new PublicKey(account), {
      //     mint: new PublicKey(item.address)
      //   });
      //   console.log(item.symbol)
      //   tokenAccounts2.value.forEach((accountInfo) => {
      //     const accountData = accountInfo.account.data.parsed.info;
      //     const tokenAmount = accountData.tokenAmount.uiAmount;
      //     if (item.address == accountData.mint) {
      //       if (tokenAmount > 0) {
      //         item.balance = Math.floor(tokenAmount * 10000) / 10000;
      //         item.balanceAll = item.balance;
      //         item.balanceDecimals = accountData.tokenAmount.amount;
      //       } else {
      //         item.balance = 0
      //       }
      //     }
      //   });
      // }
    }
    return tokenList;
  } catch (err) {
    return tokenList;
  }
}

export const getAllowance = async (tokenAddress, contractAddress) => {
  try {
    const tokenContract = new myWallet.eth.Contract(ERC20_ABI, tokenAddress);
    const result = await tokenContract.methods.allowance(
      state.account,
      contractAddress
    ).call();
    return result;
  } catch (e) {
    // throw e;
    return 0
  }
};

export const sendApproveTo = async (tokenAddress, contractAddress, amount, gasPrice) => {
  try {
    const tokenContract = new myWallet.eth.Contract(ERC20_ABI, tokenAddress);
    const result = await tokenContract.methods.approve(contractAddress, amount).send({
      from: state.account,
      gasPrice
    });
    return result;
  } catch (e) {
    return 0
  }
};

export const checkApprove = async (tokenAddress, contractAddress, amount, gasPrice) => {
  // get allowance
  const result = await getAllowance(tokenAddress, contractAddress);
  if (BigNumber(result).comparedTo(amount) < 0) {
    return await sendApproveTo(tokenAddress, contractAddress, amount, gasPrice);
  }
  return true;
};

export const checkBalance = async (tokenAddress, amount, i) => {
  try {
    const tokenContract = new myWallet.eth.Contract(ERC20_ABI, tokenAddress);
    const result = await tokenContract.methods.balanceOf(
      state.account
    ).call();
    console.log('checkBalance', result, amount);
    if (BigNumber(result).comparedTo(amount) < 0) {
      if (i > 5) {
        if (BigNumber(result).dividedBy(amount) > 0.9) {
          return result;
        } else {
          throw {
            message: "insufficient Balance"
          }
        }
      }
      await sleep(2000);
      return await checkBalance(tokenAddress, amount, i + 1);
    }
    return amount;
  } catch (e) {
    // throw e;
    return 0
  }
};


export const getGasPrice = async () => {
  const gasPrice = await myWallet.eth.getGasPrice();
  return parseInt(gasPrice * 1.2);
};


export async function signTransactionSolana (transaction) {
  return new Promise(async (r, j) => {
    try {

      let signed = null;
      if (myWallet.isCoin98) {
        const result = await myWallet.request({
          method: "sol_sign",
          params: [transaction],
        });
        console.log("Got signature, submitting transaction");
        const bytes = bs58.decode(result.signature);
        transaction.signatures[0].signature = bytes;
        transaction.feePayer = new PublicKey(swapParams.account);
        signed = transaction;
      } else if (myWallet.isSlopeWallet) {
        const { msg, data } = await myWallet.signTransaction(
          bs58.encode(transaction.serializeMessage ? transaction.serializeMessage() : transaction.message.serialize())
        );
        if (msg !== "ok") return;
        const bytes = bs58.decode(data.signature);
        transaction.signatures[0].signature = bytes;
        transaction.feePayer = new PublicKey(swapParams.account);
        signed = transaction;
      } else {
        signed = await myWallet.signTransaction(transaction);
      }
      r(signed)
    } catch (e) {
      j(e.message);
    }
  })
}

export async function sendSolanaTransaction (transaction) {
  return new Promise(async (r, j) => {
    try {

      let signed = null;
      if (myWallet.isCoin98) {
        const result = await myWallet.request({
          method: "sol_sign",
          params: [transaction],
        });
        console.log("Got signature, submitting transaction");
        const bytes = bs58.decode(result.signature);
        transaction.signatures[0].signature = bytes;
        transaction.feePayer = new PublicKey(swapParams.account);
        signed = transaction;
      } else if (myWallet.isSlopeWallet) {
        const { msg, data } = await myWallet.signTransaction(
          bs58.encode(transaction.serializeMessage ? transaction.serializeMessage() : transaction.message.serialize())
        );
        if (msg !== "ok") return;
        const bytes = bs58.decode(data.signature);
        transaction.signatures[0].signature = bytes;
        transaction.feePayer = new PublicKey(swapParams.account);
        signed = transaction;
      } else {
        signed = await myWallet.signTransaction(transaction);
      }
      let serializedTransaction = signed.serialize({
        verifySignatures: false,
        requireAllSignatures: false
      })

      const transactionResponse = await transactionSenderAndConfirmationWaiter({
        serializedTransaction
      });
      if (transactionResponse && transactionResponse.response) {
        if (transactionResponse.response.meta?.err) {
          j(transactionResponse.response.meta?.err);
        } else {
          r(transactionResponse.txid);
        }
      } else {
        j('Transaction not confirmed.');
      }
    } catch (e) {
      j(e.message);
    }
  })
}
export async function transactionSenderAndConfirmationWaiter ({
  serializedTransaction,
}) {
  let solanaConnection=await getSolanaConnection()
  const txid = await solanaConnection.sendRawTransaction(
    serializedTransaction,
    {
      skipPreflight: true,
    }
  );
  console.log('txid', txid)
  const controller = new AbortController();
  const abortSignal = controller.signal;

  const abortableResender = async () => {
    while (true) {
      await sleep(5000);
      if (abortSignal.aborted) return;
      try {
        let id = await solanaConnection.sendRawTransaction(
          serializedTransaction,
          {
            skipPreflight: true,
          }
        );
        console.log('Resender-------------')
        console.log(id)
      } catch (e) {
        console.warn(`Failed to resend transaction: ${e}`);
      }
    }
  };

  try {
    abortableResender();
    let times = 0
    let races = [
      new Promise(async (resolve) => {
        while (!abortSignal.aborted) {
          times++
          if (times > 8) resolve('')
          await sleep(2000);
          const tx = await solanaConnection.getSignatureStatus(txid, {
            searchTransactionHistory: false,
          });
          if (tx?.value?.confirmationStatus === "confirmed") {
            resolve(tx);
          }
        }
      }),
    ]
    await Promise.race(races);
  } catch (e) {
    if (e instanceof TransactionExpiredBlockheightExceededError) {
      return null;
    } else {
      throw e;
    }
  } finally {
    controller.abort();
  }
  const response = promiseRetry(
    async (retry) => {
      const response = await solanaConnection.getTransaction(txid, {
        commitment: "confirmed",
        maxSupportedTransactionVersion: 0,
      });
      if (!response) {
        retry(response);
      }
      return response;
    },
    {
      retries: 2,
      minTimeout: 3000,
    }
  );
  return { response, txid };
}


